import * as tslib_1 from "tslib";
import { EventBase } from "@awayjs/core";
var ResizeEvent = (function (_super) {
    tslib_1.__extends(ResizeEvent, _super);
    function ResizeEvent() {
        return _super.apply(this, arguments) || this;
    }
    return ResizeEvent;
}(EventBase));
export { ResizeEvent };
